<template>
  <div class="about">
    <div class="head">
      <span style="float: left; line-height: 55px">
        <i class="el-icon-arrow-left" @click="$router.back(-1)"></i
        >线上订单</span
      >
      <div id="box" ref="box">
        <div
          class="marquee-box"
          ref="marquee"
          @mouseover="menter"
          @mouseleave="mleave"
        >
          <p ref="cmdlist" id="pWidth" @click="detail(i)">
            <i class="el-icon-s-flag" style="color: red"></i>{{ gg }}
          </p>
        </div>
      </div>
      <img :src="imge" width="40" height="40" class="touimg" />
      <!-- <el-card class="notice">
        <el-carousel
          indicator-position="none"
          arrow="never"
          direction="horizontal"
          :interval="6000"
          :loop="true"
        >
          <el-carousel-item v-for="(i, ind) in newlist" :key="ind" class="notice_item">
            <i class="el-icon-s-flag" style="color: red"></i
            ><span @click="detail(i)" style="cursor: pointer"> {{ i.title }}</span>
          </el-carousel-item>
        </el-carousel>
      </el-card> -->
      <h2 class="spname">{{ shopname }}[{{ dptype }}]</h2>
    </div>
    <el-date-picker
      v-model="start"
      type="date"
      placeholder="开始日期"
      format="yyyy 年 MM 月 dd 日"
      value-format="yyyy-MM-dd"
      style="width: 100px"
    >
    </el-date-picker>
    至
    <el-date-picker
      v-model="end"
      type="date"
      placeholder="结束日期"
      format="yyyy 年 MM 月 dd 日"
      value-format="yyyy-MM-dd"
      style="width: 100px"
    >
    </el-date-picker>
    <label for="" style="margin-left: 20px">收银员：</label>
    <el-input
      placeholder="请输入内容"
      v-model="syinput"
      style="width: 100px"
      clearable
    >
    </el-input>
    <label for="" style="margin-left: 20px">付款人手机号：</label>
    <el-input
      placeholder="请输入内容"
      v-model="input"
      style="width: 120px"
      clearable
    >
    </el-input>
    <label for="" style="margin-left: 20px">付款人卡号：</label>
    <el-input
      placeholder="请输入内容"
      v-model="cardinput"
      style="width: 120px"
      clearable
    >
    </el-input>
    <label for="" style="margin-left: 20px">付款人姓名：</label>
    <el-input
      placeholder="请输入内容"
      v-model="nameinput"
      style="width: 100px"
      clearable
    >
    </el-input>
    <el-button type="warning" @click="getUser" style="margin-left: 20px"
      >查看</el-button
    >
    <br /><br />
    <!-- 内容区域 -->
    <el-main id="main" class="main">
      <Breadcrumb></Breadcrumb>
      <div style="text-align: left">
        <!-- <h5>零售汇总：{{ lingshou }}元</h5>
        <h5>退货汇总：{{ tuihuo }} 元</h5>
        <h5>纯利润：{{ lirun }}元</h5> -->
        <!-- <el-input v-model="lingshou" placeholder="请输入内容" style="width: 200px;" ref='sd' id="sd" disabled></el-input> -->
        <!-- <el-input v-model="tuihuo" placeholder="请输入内容" style="width: 200px;" disabled></el-input> -->
      </div>
      <!-- 表格 -->
      <div class="table">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column fixed prop="order_id" label="ID"> </el-table-column>
          <el-table-column fixed prop="order_number" label="订单编号">
          </el-table-column>
          <el-table-column prop="sy_nickname" label="收银员"> </el-table-column>
          <el-table-column prop="nickname" label="用户名"> </el-table-column>
          <el-table-column prop="account" label="电话"> </el-table-column>
          <el-table-column prop="cardnum" label="卡号"> </el-table-column>
          <el-table-column prop="create_time" label="结账时间">
          </el-table-column>
          <!-- <el-table-column prop="shop_name" label="消费点" width="300">
          </el-table-column> -->
          <el-table-column prop="total_price" label="总金额"> </el-table-column>
          <el-table-column prop="total_xj" label="总现金"> </el-table-column>
          <el-table-column prop="total_integral" label="总积分">
          </el-table-column>
          <el-table-column prop="refund_money" label="退货额">
          </el-table-column>
          <el-table-column prop="refund_integral" label="退货积分">
          </el-table-column>
          <el-table-column
            label="支付状态"
            prop="pay_status"
            :formatter="stateFormat"
          ></el-table-column>
          <el-table-column prop="name" label="收货人"> </el-table-column>
          <el-table-column prop="mobile" label="收货电话"> </el-table-column>
          <el-table-column prop="city_id" label="收货地址">
            <template slot-scope="scope">
              {{ scope.row.city_id }}{{ scope.row.area_id
              }}{{ scope.row.business_id }}{{ scope.row.addr }}
            </template>
          </el-table-column>
           <el-table-column
            label="物流状态"
            prop="status"
            :formatter="stateFormatwl"
          ></el-table-column>
            <el-table-column prop="express_code" label="快递名称"> </el-table-column>
              <el-table-column prop="express_num" label="快递单号"> </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row, scope.$index)"
                type="text"
                size="medium"
                >查看</el-button
              >
              <el-button @click="handleClickd(scope.row)" type="text"
                >发货</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- /End 表格 -->
      <div>
        <el-dialog title="" :visible.sync="visible" width="90%">
          <el-table :data="gridData" height="520">
            <el-table-column property="id" label="编码"></el-table-column>
            <el-table-column property="title" label="名称"></el-table-column>
            <el-table-column property="photo" label="商品">
              <template slot-scope="scope">
                <img
                  :src="scope.row.photo"
                  @error="defImg()"
                  width="40"
                  height="40"
                />
              </template>
            </el-table-column>
            <el-table-column property="price" label="原价"></el-table-column
            >give_integral
            <el-table-column
              property="give_integral"
              label="赠送积分"
            ></el-table-column>
            <el-table-column property="discount" label="折扣"></el-table-column>
            <el-table-column
              property="discount_price"
              label="折扣价"
            ></el-table-column>
            <el-table-column property="num" label="数量"></el-table-column>
            <el-table-column
              property="total_price"
              label="总价"
            ></el-table-column>
            <el-table-column
              property="refund_num"
              label="已退"
            ></el-table-column>
            <el-table-column
              property="refund_money"
              label="退货额"
            ></el-table-column>
            <el-table-column property="xj" label="现金"></el-table-column>
            <el-table-column
              property="total_xj"
              label="总现金"
            ></el-table-column>
            <el-table-column
              property="total_give_integral"
              label="总积分"
            ></el-table-column>
            <el-table-column
              property="refund_integral"
              label="退货积分"
            ></el-table-column>
            <!-- <el-table-column
                label="状态"
                prop="refund_status"
                :formatter="stateFormat"
              ></el-table-column> -->

            <!-- <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="handleClicks(scope.row, scope.$index)"
                  type="text"
                  size="medium"
                  >退货</el-button
                >
              </template>
            </el-table-column> -->
          </el-table>
        </el-dialog>
      </div>
      <div>
        <el-popover
          placement="left"
          width="780px"
          trigger="manual"
          :offset="300"
          v-model="visibles"
          ><br /><br />
          <div class="spbiao">
            快递名称：
            <el-input
              v-model="kdname"
              placeholder="请输入内容"
              style="width: 300px"
            ></el-input
            ><br />
            <br />
            快递单号：
            <el-input
              v-model="kdnum"
              placeholder="请输入内容"
              style="width: 300px"
            ></el-input
            ><br /><br />
            <el-button type="success" @click="xiugai">确定</el-button>
            <el-button :plain="true" @click="noxiu">取消</el-button>
          </div>
        </el-popover>
      </div>

      <!-- <Pagination></Pagination> -->

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[100, 300, 500]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- /End 分页 -->
    </el-main>
    <!-- /End 内容区域 -->
  </div>
</template>

<script>
// import axios from "axios";
export default {
  name: "linelist",
  data() {
    return {
      start: "",
      defaultImg: require("../../static/1.png"),
      end: "",
      input: "",
      syinput: "",
      cardinput: "",
      nameinput: "",
      gridData: [],
      imge: "",
      lingshou: 0,
      tuihuo: 0,
      lirun: 0,
      shopname: "",
      myInstance: null, // axios实例
      tableData: [], // 表格数据
      visible: false,
      visibles: false, //发货
      currentPage: 1, // 当前页码
      total: 0, // 总条目数
      query: "", // 查询参数
      pagenum: 1, // 当前页码
      pagesize: 100, // 每页显示条数
      dptype: "",
      newlist: [],
      cardid: "",
      kdname: "", //快递名称
      kdnum: "", //快递单号
      timer: "", //计时器
      pwidth: 0, //公告文本的宽度
      value: 0,
      gg: "",
      i: "",
      titleStr: "",
      // windowWidth:'', // box宽度
      windowWidth: document.documentElement.clientWidth / 2.5,
    };
  },
  mounted() {
    let element = this.$refs.cmdlist;
    this.pwidth = document.defaultView
      .getComputedStyle(element, "")
      .width.split("px");
    this.timer = setInterval(this.clickCommend, 20);
    this.getUser();
    this.shopname = localStorage.getItem("shopname");
    this.imge = localStorage.getItem("imge");
    var type_id = localStorage.getItem("type_id");
    if (type_id == 3) {
      this.dptype = "易货店";
    } else if (type_id == 5) {
      this.dptype = "折扣仓";
    }
    this.$axios.post(this.$api.new, {}).then((res) => {
      if (res.code == 1) {
        this.newlist = res.data;
        this.gg = this.newlist[0].title;
        this.i = 0;
      }
    });
    // this.$axios.post(this.$api.shopinfo, {}).then((res) => {
    //   if (res.code == 1) {
    //     console.log(res.data.shop_name);
    //     this.shopname = res.data.shop_name;
    //     this.imge = res.data.logo;
    //     // this.sdyingshou = res.data.total_price
    //     // this.sdshishou = res.data.total_price
    //   }
    // });
  },
  watch: {
    value(newValue, oldValue) {
      let allWidth = parseInt(this.windowWidth) + parseInt(this.pwidth[0]);
      console.log(oldValue);
      if (newValue <= -allWidth) {
        this.$refs.cmdlist.style.marginLeft = this.windowWidth + "px";
        this.value = 0;
      }
    },
  },
  methods: {
    clickCommend(e) {
      console.log(e);
      let _this = this;
      this.$nextTick(() => {
        this.value -= 1;
        this.$refs.cmdlist.style.marginLeft =
          _this.windowWidth + this.value + "px";
      });
    },
    menter() {
      clearInterval(this.timer);
    },
    mleave() {
      this.timer = setInterval(this.clickCommend, 20);
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    detail(i) {
      this.$router.push({
        name: "proinfo",
        params: {
          details: this.newlist[i].details,
          title: this.newlist[i].title,
        },
      });
    },
    defImg() {
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    cha() {
      this.pagenum = 1;
      this.getUser();
    },
    getUser() {
      this.$axios
        .post(this.$api.linelist, {
          cardnum: this.cardinput, // 查询参数
          account: this.input,
          sy_nickname: this.syinput,
          nickname: this.nameinput,
          id: this.$route.query.id,
          start_time: this.start,
          end_time: this.end,
          page: this.pagenum, // 当前页码
          page_size: this.pagesize, // 每页显示条数
        })
        .then((res) => {
          this.tableData = res.data.list; // 表格数据
          this.total = res.data.count; // 总条目数
          this.lingshou = res.data.total_income; //零售汇总
          this.tuihuo = res.data.total_refund; //退货汇总
          this.lirun = res.data.total_profit; //利润
        });
    },
    stateFormat(row) {
      if (row.pay_status === 1) {
        return "已支付";
      } else {
        return "未支付";
      }
    },
     stateFormatwl(row) {
      if (row.status === -1) {
        return "订单关闭";
      } else if (row.status === 0) {
        return "未付款";
      }else if (row.status === 1) {
        return "已付款";
      }else if (row.status === 2) {
        return "待发货";
      }else if (row.status === 3) {
        return "已收货";
      }else if (row.status === 4) {
        return "申请退款";
      }else if (row.status === 5) {
        return "同意退款";
      }else if (row.status === 6) {
        return "拒绝退款";
      }else if (row.status === 8) {
        return "已发货";
      }else{
        return "正在更新";
      }
    },
    handleClickd(row) {
      console.log(row.order_id);
      this.visibles = true;
      this.cardid = row.order_id;
    },
    xiugai() {
      //最终商品结算
      this.$confirm("请您确定, 是否继续?", "提示", {
        //弹框确定继续操作
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.fahuo, {
              order_id: this.cardid,
              express_code: this.kdname,
              express_num: this.kdnum,
              // confirm_password: this.twopas,
            })
            .then((res) => {
              if (res.code == 1) {
                //判断是否结算成功
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.visibles = false;
                this.kdname = "";
                this.kdnum = "";
                this.getUser();
                // location.reload() //刷新页面
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
          this.visibles = false;
        });
    },
    noxiu() {
      //取消结算
      this.$message({
        message: "取消修改",
        type: "warning",
      });
      this.visibles = false;
    },
    handleClick(row, index) {
      console.log(row);
      console.log(index);
      this.$axios
        .post(this.$api.handleClick, {
          order_id: row.order_id,
        })
        .then((res) => {
          this.visible = true;
          this.gridData = res.data; // 表格数据
          // console.log(res);
          // for (var i = 0; i < res.data.length; i++) {
          // 	console.log(res.data[i].refund_status);
          // 	if (res.data[i].refund_status == 1) {}
          // }
          // console.log(res.data.refund_status);
        });
    },
    handleClicks(row, index) {
      console.log(row);
      console.log(index);
      var num = window.prompt("退货数量", "");
      if (num != null && num != "") {
        console.log(num);
        var msg = "您真的确定要退货吗？\n\n请确认！";
        if (confirm(msg) == true) {
          this.$axios
            .post(this.$api.tuihuo, {
              id: row.id,
              refund_num: num,
            })
            .then((res) => {
              if (res.code == 1) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.visible = false;
                // location.reload(); //刷新页面
                this.getUser();
              } else {
                this.visible = false;
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            });
          // return true;
        } else {
          return false;
        }
      }
    },
    handleSizeChange(val) {
      //改变时
      this.pagesize = val;
      this.getUser();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //条目改变时
      this.pagenum = val;
      this.getUser();
      console.log(`当前页: ${val}`);
    },
  },
  computed: {},
};
</script>
<style scoped>
#box {
  width: 60%;
  vertical-align: middle;
  display: inline-block;
  margin-right: 5%;
  background: #50a3e5;
  color: #fff;
  white-space: nowrap;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
.marquee-box {
  overflow: auto;
}
#pWidth {
  width: 60%;
  height: 50px;
  padding: 0;
  margin: 0;
  line-height: 50px;
  display: block;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  font-family: 微软雅黑;
  font-size: 14px;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.spbiao {
  width: 70%;
  left: 12%;
  min-height: 200px;
  position: fixed;
  background: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
  top: 15%;
  padding: 2%;
}

.head {
  text-align: right;
  background: #50a3e5;
  color: white;
  padding: 10px;
  margin: 15px;
}

.touimg {
  width: 45px;
  height: 45px;
  vertical-align: middle;
  border-radius: 50%;
}

.spname {
  font-size: 18px;
  display: inline-block;
  margin-left: 15px;
}
h5 {
  display: inline-block;
  width: 30%;
}
.notice {
  width: 65%;
  height: 50px;
  top: 25px;
  left: 50%;
  transform: translate(-50%);
  position: absolute;
}
.notice /deep/ .el-card__body {
  padding: 0;
}
/*使文字和公告图片在一行*/
.notice_item {
  height: 50px;
  line-height: 50px;
  background: #50a3e5;
  color: white;
  white-space: nowrap;
  font-size: 14px;
  /* background-color: #fff; */
  display: flex;
  flex-direction: row;
  align-items: center;
}
.notice_item img {
  width: 40px;
  /*height: 16px;*/
  margin: 0 44px 0 32px;
}
.el-card {
  border: none;
}
</style>
